var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMeet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_798_5242)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9854 9.92139L12.4476 11.5928L14.4139 12.8494L14.7568 9.93167L14.4139 7.0791L12.4099 8.1831L10.9854 9.92139Z",
    fill: "#00832D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 12.5787V15.0645C2.5 15.6327 2.96029 16.093 3.52857 16.093H6.01429L6.52857 14.2142L6.01429 12.5787L4.30857 12.0645L2.5 12.5787Z",
    fill: "#0066DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.01429 3.75L2.5 7.26429L4.30857 7.77857L6.01429 7.26429L6.52 5.65114L6.01429 3.75Z",
    fill: "#E94235"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.01429 7.26465H2.5V12.5789H6.01429V7.26465Z",
    fill: "#2684FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6604 5.23772L14.4146 7.07886V12.8491L16.6706 14.6989C17.0084 14.9629 17.5021 14.722 17.5021 14.2926V5.63543C17.5021 5.20086 16.9972 4.96257 16.6604 5.23772ZM10.9861 9.92115V12.5783H6.01465V16.0926H13.3861C13.9544 16.0926 14.4146 15.6323 14.4146 15.064V12.8491L10.9861 9.92115Z",
    fill: "#00AC47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3861 3.75H6.01465V7.26429H10.9861V9.92143L14.4146 7.08086V4.77857C14.4146 4.21029 13.9544 3.75 13.3861 3.75Z",
    fill: "#FFBA00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_798_5242"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 12.3429,
    fill: "white",
    transform: "translate(2.5 3.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeet);
export default __webpack_public_path__ + "static/media/meet.e767a1a92aff675bbd161d9b25d11087.svg";
export { ForwardRef as ReactComponent };